import LargeHeading from '@components/atoms/LargeHeading';
import ContentBox from '@components/atoms/ContentBox';
import Typography from '@components/atoms/Typography';
import CheckList from '@components/atoms/CheckList';

import classes from './ProsSection.module.scss';

const ProsSection = (): JSX.Element => (
  <div className={classes.wrapper}>
    <LargeHeading title="Korzyści wynikające z posiadanych statusów partnerskich " />
    <div className={classes.boxes}>
      <ContentBox>
        <Typography variant="h1" renderAs="div" className={classes.title}>
          Dla klienta:
        </Typography>
        <CheckList listStyle="unordered" size="h2" color="blue">
          <CheckList.Item>ceny projektowe</CheckList.Item>
          <CheckList.Item>dostęp do produktów spoza oferty standardowej</CheckList.Item>
          <CheckList.Item>dostęp do produktów demo</CheckList.Item>
          <CheckList.Item>bezpośrednie wsparcie producenta</CheckList.Item>
        </CheckList>
      </ContentBox>
      <ContentBox>
        <Typography variant="h1" renderAs="div" className={classes.title}>
          Dla nas:
        </Typography>
        <CheckList listStyle="unordered" size="h2" color="blue">
          <CheckList.Item>najnowsza wiedza techniczna i produktowa</CheckList.Item>
          <CheckList.Item>cykliczne szkolenia produktowe i techniczne</CheckList.Item>
          <CheckList.Item>certyfikacje kompetencyjne dla inżynierów</CheckList.Item>
          <CheckList.Item>tworzenie rozwiązań Proof of Concept</CheckList.Item>
        </CheckList>
      </ContentBox>
    </div>
  </div>
);

export default ProsSection;
